// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll(".client-reviews").forEach(section => {
//     const carousel = section.querySelector(".reviews-carousel");
//     if (!carousel) return;

//     // ...rest of your slider logic...
//     const track = carousel.querySelector(".reviews-track");
//     const slides = carousel.querySelectorAll(".review-card");
//     const dotsContainer = carousel.querySelector(".reviews-dots");
    
//     let currentIndex = 0;
    
//     // 🔥 Fix: set widths
//     track.style.width = `${slides.length * 100}%`;
//     slides.forEach(slide => {
//       slide.style.width = `${100}%`; // each slide fills viewport
//     });
    
//     // Create dots
//     slides.forEach((_, i) => {
//       const dot = document.createElement("span");
//       dot.classList.add("dot");
//       if (i === 0) dot.classList.add("active");
//       dot.addEventListener("click", () => goToSlide(i));
//       dotsContainer.appendChild(dot);
//     });
    
//     const dots = dotsContainer.querySelectorAll(".dot");
    
//     function goToSlide(index) {
//       currentIndex = index;
//       track.style.transform = `translateX(-${index * 100}%)`;
//       dots.forEach(d => d.classList.remove("active"));
//       dots[index].classList.add("active");
//     }
    
//     function autoPlay() {
//       currentIndex = (currentIndex + 1) % slides.length;
//       goToSlide(currentIndex);
//     }
    
//     let autoPlayInterval = setInterval(autoPlay, 4000);
    
//     carousel.addEventListener("mouseenter", () => clearInterval(autoPlayInterval));
//     carousel.addEventListener("mouseleave", () => autoPlayInterval = setInterval(autoPlay, 4000));
//   });
// });




document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".client-reviews").forEach(section => {
    const carousel = section.querySelector(".reviews-carousel");
    if (!carousel) return;

    const track = carousel.querySelector(".reviews-track");
    const slides = carousel.querySelectorAll(".review-card");
    const dotsContainer = carousel.querySelector(".reviews-dots");

    let currentIndex = 0;

    // ✅ Each slide should be 100% / slides.length of track
    track.style.width = `${slides.length * 100}%`;
    slides.forEach(slide => {
      slide.style.flex = `0 0 ${100 / slides.length}%`;
      slide.style.maxWidth = `${100 / slides.length}%`;
    });

    // Create dots
    slides.forEach((_, i) => {
      const dot = document.createElement("span");
      dot.classList.add("dot");
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => goToSlide(i));
      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll(".dot");

    function goToSlide(index) {
      currentIndex = index;
      track.style.transform = `translateX(-${index * (100 / slides.length)}%)`;
      dots.forEach(d => d.classList.remove("active"));
      dots[index].classList.add("active");
    }

    function autoPlay() {
      currentIndex = (currentIndex + 1) % slides.length;
      goToSlide(currentIndex);
    }

    let autoPlayInterval = setInterval(autoPlay, 4000);

    carousel.addEventListener("mouseenter", () => clearInterval(autoPlayInterval));
    carousel.addEventListener("mouseleave", () => autoPlayInterval = setInterval(autoPlay, 4000));
  });
});
